import { jobActions } from "redux/_core/job";
import { ActionType, createAction, getType } from "typesafe-actions";
import reportConstants from "./constants";
import {
	ECNR_BASE_RANGE_TYPE,
	IBilgeWaterAllVesselAggregateRecord,
	IBilgeWaterRecord,
	ICNRRangeColumn,
	ICNRRangeVessel,
	ICNRRangeVesselLocalRange,
	ICNRRangesVesselsLoadParams,
	ICargoSlopAggregateRecord,
	ICargoSlopVesselSpecificAggregateRecord,
	ICellRangeUpdatePayload,
	IComprehensiveNoonReportRecord,
	IComprehensiveNoonReportVesselSpecificDataRecord,
	IGarbageCategoryAllVesselsRecord,
	IGarbageDischargeAllVesselsRecord,
	IGarbageCustomSearchRecord,
	IGarbageRawRecord,
	IORSAggregateRecord,
	IORSVesselSpecificAggregateRecord,
	IOilSpillsInWaterAggregateRecord,
	IOilSpillsInWaterVesselSpecificAggregateRecord,
	IPagination,
	IPackagingAllVesselAggregatedData,
	IPackagingVesselSpecificAggregatedData,
	ICleaningChemicalsAllVesselAggregatedData,
	ICleaningChemicalsVesselSpecificAggregatedData,
	IEmissionsAllVesselAggregatedData,
	IEmissionsVesselSpecificAggregatedData,
	IRefrigerantAllVesselAggregatedData,
	IRefrigerantVesselSpecificAggregatedData,
	IRefrigerantCustomSearchRecord,
	IBilgeWaterCustomSearchRecord,
	IPackagingCustomSearchRecord,
	ICleaningChemicalsCustomSearchRecord,
	IORSCustomSearchRecord,
	ICargoSlopCustomSearchRecord,
	IEmissionsCustomSearchRecord,
	TBFL1UsageData,
	TBFL2UsageData,
} from "./@types";
import { TEMFUsageData } from "../emf/@types";

export enum EReportActions {
	REPORT_GARBAGE_LOAD = "@report/garbage/LOAD",

	REPORT_BILGE_WATER_LOAD = "@report/bilge-water/LOAD",
	REPORT_BILGE_WATER_ALL_VESSELS_AGGREGATE_LOAD = "@report/bilge-water/all-vessels/aggregate/LOAD",
	REPORT_GARBAGE_DISCHARGE_ALL_VESSELS_LOAD = "@report/all-vessels/garbage-discharge/LOAD",
	REPORT_GARBAGE_CATEGORY_ALL_VESSELS_LOAD = "@report/all-vessels/garbage-category/LOAD",

	REPORT_ORS_VESSEL_SPECIFIC_AGGREGATE_LOAD = "@report/ors/vessel-specific/aggregate/LOAD",
	REPORT_ORS_ALL_VESSEL_AGGREGATE_LOAD = "@report/ors/all-vessel/aggregate/LOAD",

	REPORT_CARGO_SLOP_VESSEL_SPECIFIC_AGGREGATE_LOAD = "@report/cargo-slop/vessel-specific/aggregate/LOAD",
	REPORT_CARGO_SLOP_ALL_VESSEL_AGGREGATE_LOAD = "@report/cargo-slop/all-vessel/aggregate/LOAD",

	REPORT_OIL_SPILLS_IN_WATER_VESSEL_SPECIFIC_AGGREGATE_LOAD = "@report/oil-spills-in-water/vessel-specific/aggregate/LOAD",
	REPORT_OIL_SPILLS_IN_WATER_ALL_VESSEL_AGGREGATE_LOAD = "@report/oil-spills-in-water/all-vessel/aggregate/LOAD",

	REPORT_COMPREHENSIVE_NOON_REPORT_ALL_VESSEL_LOAD = "@report/comprehensive-noon-report/all-vessel/LOAD",
	REPORT_COMPREHENSIVE_NOON_REPORT_VESSEL_SPECIFIC_DATA_LOAD = "@report/comprehensive-noon-report/vessel-specific/data/LOAD",

	REPORT_CNR_RANGES_VESSELS_LOAD = "@report/cnr-ranges/vessels/LOAD",
	REPORT_CNR_RANGES_VESSEL_SUB_TYPE_CONFIG_LOAD = "@report/cnr-ranges/vessel-subtype-specific-config/LOAD",
	REPORT_CNR_RANGES_RANGE_CELL_UPDATE = "@report/cnr-ranges/range-cell/UPDATE",

	REPORT_NAVNUC_LOAD = "@report/nav-nuc/LOAD",
	REPORT_CNR_RANGES_CSV_FILE_UPLOAD = "@report/cnr-ranges/csv-file/UPLOAD",

	// Environmental Reports (EMF)
	REPORT_PACKAGING_VESSEL_SPECIFIC_AGGREGATE_DATA_LOAD = "@report/packaging/vessel-specific/data/LOAD",
	REPORT_PACKAGING_ALL_VESSEL_AGGREGATE_DATA_LOAD = "@report/packaging/all-vessel/data/LOAD",

	REPORT_CLEANING_CHEMICALS_VESSEL_SPECIFIC_AGGREGATE_DATA_LOAD = "@report/cleaning-chemicals/vessel-specific/data/LOAD",
	REPORT_CLEANING_CHEMICALS_ALL_VESSEL_AGGREGATE_DATA_LOAD = "@report/cleaning-chemicals/all-vessel/data/LOAD",

	REPORT_EMISSIONS_VESSEL_SPECIFIC_AGGREGATE_DATA_LOAD = "@report/emissions/vessel-specific/data/LOAD",
	REPORT_EMISSIONS_ALL_VESSEL_AGGREGATE_DATA_LOAD = "@report/emissions/all-vessel/data/LOAD",

	REPORT_REFRIGERANT_VESSEL_SPECIFIC_AGGREGATE_DATA_LOAD = "@report/refrigerant/vessel-specific/data/LOAD",
	REPORT_REFRIGERANT_ALL_VESSEL_AGGREGATE_DATA_LOAD = "@report/refrigerant/all-vessel/data/LOAD",

	REPORT_FLEET_EMF_USAGE_DATA_LOAD = "@report/emf/all-vessel/data/LOAD",

	REPORT_FLEET_BIOFOULING1_DATA_LOAD = "@report/biofouling-1/all-vessel/data/LOAD",
	REPORT_FLEET_BIOFOULING2_DATA_LOAD = "@report/biofouling-2/all-vessel/data/LOAD",

	// INFO: Making it generic, rather than for each category-type
	REPORT_YEAR_SET = "@report/year/SET",
	REPORT_VESSEL_ID_SET = "@report/vesselId/SET",
	REPORT_VESSEL_TYPE_SET = "@report/vesselType/SET",
	REPORT_VESSEL_CLASS_SET = "@report/vesselClass/SET",
	REPORT_FILTERS_SET = "@report/filters/SET",
	REPORT_PAGINATION_SET = "@report/pagination/SET",

	REPORT_GARBAGE_RAW_DATA_SET = "@report/garbage/raw/SET",
	REPORT_GARBAGE_VESSEL_ID_SET = "@report/garbage/vesselId/SET",
	REPORT_GARBAGE_YEAR_SET = "@report/garbage/year/SET",
	REPORT_ALL_VESSELS_GARBAGE_DISCHARGE_SET = "@report/all-vessels/garbage-discharge/data/SET",
	REPORT_ALL_VESSELS_GARBAGE_CATEGORY_SET = "@report/all-vessels/garbage-category/data/SET",

	REPORT_BILGE_WATER_RAW_DATA_SET = "@report/bilge-water/raw/SET",
	REPORT_BILGE_WATER_VESSEL_ID_SET = "@report/bilge-water/vesselId/SET",
	REPORT_BILGE_WATER_YEAR_SET = "@report/bilge-water/year/SET",
	REPORT_BILGE_WATER_ALL_VESSELS_DATA_SET = "@report/bilge-water/all-vessels/data/SET",

	REPORT_ORS_AGGREGATE_DATA_SET = "@report/ors/data/SET",
	REPORT_ORS_VESSEL_SPECIFIC_AGGREGATE_DATA_SET = "@report/ors/vessel-specific/data/SET",
	REPORT_ORS_VESSEL_ID_SET = "@report/ors/vesselId/SET",
	REPORT_ORS_YEAR_SET = "@report/ors/year/SET",

	REPORT_CARGO_SLOP_AGGREGATE_DATA_SET = "@report/cargo-slop/data/SET",
	REPORT_CARGO_SLOP_VESSEL_SPECIFIC_AGGREGATE_DATA_SET = "@report/cargo-slop/vessel-specific/data/SET",

	REPORT_OIL_SPILLS_IN_WATER_AGGREGATE_DATA_SET = "@report/oil-spills-in-water/data/SET",
	REPORT_OIL_SPILLS_IN_WATER_VESSEL_SPECIFIC_AGGREGATE_DATA_SET = "@report/oil-spills-in-water/vessel-specific/data/SET",

	REPORT_COMPREHENSIVE_NOON_REPORT_DATA_SET = "@report/comprehensive-noon-report/data/SET",
	REPORT_COMPREHENSIVE_NOON_REPORT_VESSEL_SPECIFIC_DATA_SET = "@report/comprehensive-noon-report/vessel-specific/data/SET",

	REPORT_CNR_RANGES_VESSEL_LIST_SET = "@report/cnr-ranges/vessel-list/SET", //This does the work of incrementally adding new loaded vessels
	REPORT_CNR_RANGES_VESSEL_LIST_RESET = "@report/cnr-ranges/vessel-list/RESET",
	REPORT_CNR_RANGES_PAGINATION_SET = "@report/cnr-ranges/pagination/SET",
	REPORT_CNR_RANGES_COLUMNS_SET = "@report/cnr-ranges/columns/SET",
	REPORT_CNR_RANGES_VESSEL_SUB_TYPE_SET = "@report/cnr-ranges/vessel-sub-type/SET",
	REPORT_CNR_RANGES_VESSELS_SELECTED = "@report/cnr-ranges/vessels-selected/SET",
	REPORT_CNR_RANGES_REPORT_TYPE_SELECTED = "@report/cnr-ranges/report-type-selected/SET",
	REPORT_CNR_RANGES_BASE_RANGE_TYPE_SET = "@report/cnr-ranges/range-type-selected/SET",
	REPORT_CNR_RANGES_CONFIG_SET = "@report/cnr-ranges/config/SET",
	REPORT_CNR_RANGES_IS_EDIT_MODAL_VISIBLE_TOGGLE = "@report/cnr-ranges/is-edit-modal-visible/TOGGLE",
	REPORT_CNR_RANGES_RANGE_INFO_SET = "@report/cnr-ranges/range-info/SET",

	REPORT_NAVNUC_SET = "@report/nav-nuc/data/SET",

	// Environmental Reports (EMF)
	REPORT_PACKAGING_VESSEL_SPECIFIC_AGGREGATE_DATA_SET = "@report/packaging/vessel-specific/data/SET",
	REPORT_PACKAGING_ALL_VESSEL_AGGREGATE_DATA_SET = "@report/packaging/all-vessel/data/SET",

	REPORT_CLEANING_CHEMICALS_VESSEL_SPECIFIC_AGGREGATE_DATA_SET = "@report/cleaning-chemicals/vessel-specific/data/SET",
	REPORT_CLEANING_CHEMICALS_ALL_VESSEL_AGGREGATE_DATA_SET = "@report/cleaning-chemicals/all-vessel/data/SET",

	REPORT_EMISSIONS_VESSEL_SPECIFIC_AGGREGATE_DATA_SET = "@report/emissions/vessel-specific/data/SET",
	REPORT_EMISSIONS_ALL_VESSEL_AGGREGATE_DATA_SET = "@report/emissions/all-vessel/data/SET",

	REPORT_REFRIGERANT_VESSEL_SPECIFIC_AGGREGATE_DATA_SET = "@report/refrigerant/vessel-specific/data/SET",
	REPORT_REFRIGERANT_ALL_VESSEL_AGGREGATE_DATA_SET = "@report/refrigerant/all-vessel/data/SET",

	REPORT_FLEET_EMF_USAGE_DATA_SET = "@report/emf/all-vessel/data/SET",

	REPORT_FLEET_BIOFOULING1_DATA_SET = "@report/biofouling-1/all-vessel/data/SET",
	REPORT_FLEET_BIOFOULING2_DATA_SET = "@report/biofouling-2/all-vessel/data/SET",

	REPORT_GARBAGE_CUSTOM_SEARCH_LOAD = "@report/garbage/custom-search/LOAD",
	REPORT_GARBAGE_CUSTOM_SEARCH_DATA_SET = "@report/garbage/custom-search/data/SET",

	REPORT_REFRIGERANT_CUSTOM_SEARCH_LOAD = "@report/refrigerant/custom-search/LOAD",
	REPORT_REFRIGERANT_CUSTOM_SEARCH_DATA_SET = "@report/refrigerant/custom-search/data/SET",

	REPORT_BILGE_WATER_CUSTOM_SEARCH_LOAD = "@report/bilge-water/custom-search/LOAD",
	REPORT_BILGE_WATER_CUSTOM_SEARCH_DATA_SET = "@report/bilge-water/custom-search/data/SET",

	REPORT_PACKAGING_CUSTOM_SEARCH_LOAD = "@report/packaging/custom-search/LOAD",
	REPORT_PACKAGING_CUSTOM_SEARCH_DATA_SET = "@report/packaging/custom-search/data/SET",

	REPORT_CLEANING_CHEMICALS_CUSTOM_SEARCH_LOAD = "@report/cleaning-chemicals/custom-search/LOAD",
	REPORT_CLEANING_CHEMICALS_CUSTOM_SEARCH_DATA_SET = "@report/cleaning-chemicals/custom-search/data/SET",

	REPORT_ORS_CUSTOM_SEARCH_LOAD = "@report/ors/custom-search/LOAD",
	REPORT_ORS_CUSTOM_SEARCH_DATA_SET = "@report/ors/custom-search/data/SET",

	REPORT_CARGO_SLOP_CUSTOM_SEARCH_LOAD = "@report/cargo-slop/custom-search/LOAD",
	REPORT_CARGO_SLOP_CUSTOM_SEARCH_DATA_SET = "@report/cargo-slop/custom-search/data/SET",

	REPORT_EMISSIONS_CUSTOM_SEARCH_LOAD = "@report/emissions/custom-search/LOAD",
	REPORT_EMISSIONS_CUSTOM_SEARCH_DATA_SET = "@report/emissions/custom-search/data/SET",
}

const reportActions = {
	commands: {
		garbageReportLoad: createAction(EReportActions.REPORT_GARBAGE_LOAD)(),
		bilgeWaterReportLoad: createAction(
			EReportActions.REPORT_BILGE_WATER_LOAD,
		)(),
		bilgeWaterAllVesselsAggregateLoad: createAction(
			EReportActions.REPORT_BILGE_WATER_ALL_VESSELS_AGGREGATE_LOAD,
		)(),
		garbageDischargeAllVesselsLoad: createAction(
			EReportActions.REPORT_GARBAGE_DISCHARGE_ALL_VESSELS_LOAD,
		)(),
		garbageCategoryAllVesselsLoad: createAction(
			EReportActions.REPORT_GARBAGE_CATEGORY_ALL_VESSELS_LOAD,
		)(),
		orsVesselSpecificAggregateLoad: createAction(
			EReportActions.REPORT_ORS_VESSEL_SPECIFIC_AGGREGATE_LOAD,
		)(),
		orsAllVesselAggregateLoad: createAction(
			EReportActions.REPORT_ORS_ALL_VESSEL_AGGREGATE_LOAD,
		)(),
		cargoSlopVesselSpecificAggregateLoad: createAction(
			EReportActions.REPORT_CARGO_SLOP_VESSEL_SPECIFIC_AGGREGATE_LOAD,
		)(),
		cargoSlopAllVesselAggregateLoad: createAction(
			EReportActions.REPORT_CARGO_SLOP_ALL_VESSEL_AGGREGATE_LOAD,
		)(),
		oilSpillsInWaterVesselSpecificAggregateLoad: createAction(
			EReportActions.REPORT_OIL_SPILLS_IN_WATER_VESSEL_SPECIFIC_AGGREGATE_LOAD,
		)(),
		oilSpillsInWaterAllVesselAggregateLoad: createAction(
			EReportActions.REPORT_OIL_SPILLS_IN_WATER_ALL_VESSEL_AGGREGATE_LOAD,
		)(),
		comprehensiveNoonReportAllVesselLoad: createAction(
			EReportActions.REPORT_COMPREHENSIVE_NOON_REPORT_ALL_VESSEL_LOAD,
		)(),
		comprehensiveNoonReportVesselSpecificDataLoad: createAction(
			EReportActions.REPORT_COMPREHENSIVE_NOON_REPORT_VESSEL_SPECIFIC_DATA_LOAD,
		)(),
		cnrRangesVesselsLoad: createAction(
			EReportActions.REPORT_CNR_RANGES_VESSELS_LOAD,
			({
				baseRangeType,
				selectedVessels,
				paginationParams,
			}: ICNRRangesVesselsLoadParams) => ({
				baseRangeType,
				selectedVessels,
				paginationParams,
			}),
		)(),
		cnrRangesVesselSubTypeConfigLoad: createAction(
			EReportActions.REPORT_CNR_RANGES_VESSEL_SUB_TYPE_CONFIG_LOAD,
		)(),
		cnrRangesRangeCellUpdate: createAction(
			EReportActions.REPORT_CNR_RANGES_RANGE_CELL_UPDATE,
			(rangeInfo: ICellRangeUpdatePayload) => ({ rangeInfo }),
		)(),
		navnucLoad: createAction(EReportActions.REPORT_NAVNUC_LOAD)(),
		garbageCustomSearchLoad: createAction(
			EReportActions.REPORT_GARBAGE_CUSTOM_SEARCH_LOAD,
			(fromDate: string, toDate: string, vesselIds: string[]) => ({
				fromDate,
				toDate,
				vesselIds,
			}),
		)(),
		refrigerantCustomSearchLoad: createAction(
			EReportActions.REPORT_REFRIGERANT_CUSTOM_SEARCH_LOAD,
			(fromDate: string, toDate: string, vesselIds: string[]) => ({
				fromDate,
				toDate,
				vesselIds,
			}),
		)(),
		bilgeWaterCustomSearchLoad: createAction(
			EReportActions.REPORT_BILGE_WATER_CUSTOM_SEARCH_LOAD,
			(fromDate: string, toDate: string, vesselIds: string[]) => ({
				fromDate,
				toDate,
				vesselIds,
			}),
		)(),
		packagingCustomSearchLoad: createAction(
			EReportActions.REPORT_PACKAGING_CUSTOM_SEARCH_LOAD,
			(fromDate: string, toDate: string, vesselIds: string[]) => ({
				fromDate,
				toDate,
				vesselIds,
			}),
		)(),
		cleaningChemicalsCustomSearchLoad: createAction(
			EReportActions.REPORT_CLEANING_CHEMICALS_CUSTOM_SEARCH_LOAD,
			(fromDate: string, toDate: string, vesselIds: string[]) => ({
				fromDate,
				toDate,
				vesselIds,
			}),
		)(),
		orsCustomSearchLoad: createAction(
			EReportActions.REPORT_ORS_CUSTOM_SEARCH_LOAD,
			(fromDate: string, toDate: string, vesselIds: string[]) => ({
				fromDate,
				toDate,
				vesselIds,
			}),
		)(),
		cargoSlopCustomSearchLoad: createAction(
			EReportActions.REPORT_CARGO_SLOP_CUSTOM_SEARCH_LOAD,
			(fromDate: string, toDate: string, vesselIds: string[]) => ({
				fromDate,
				toDate,
				vesselIds,
			}),
		)(),
		emissionsCustomSearchLoad: createAction(
			EReportActions.REPORT_EMISSIONS_CUSTOM_SEARCH_LOAD,
			(fromDate: string, toDate: string, vesselIds: string[]) => ({
				fromDate,
				toDate,
				vesselIds,
			}),
		)(),
		cnrRangesCSVFileUpload: createAction(
			EReportActions.REPORT_CNR_RANGES_CSV_FILE_UPLOAD,
			(file: File) => ({
				file,
			}),
		)(),
		// Environmental Report (EMF) actions
		packagingVesselSpecificAggregateDataLoad: createAction(
			EReportActions.REPORT_PACKAGING_VESSEL_SPECIFIC_AGGREGATE_DATA_LOAD,
			(vesselId: string, year: string) => ({
				vesselId,
				year,
			}),
		)(),
		packagingAllVesselAggregateDataLoad: createAction(
			EReportActions.REPORT_PACKAGING_ALL_VESSEL_AGGREGATE_DATA_LOAD,
			(year: string) => ({
				year,
			}),
		)(),
		cleaningChemicalsVesselSpecificAggregateDataLoad: createAction(
			EReportActions.REPORT_CLEANING_CHEMICALS_VESSEL_SPECIFIC_AGGREGATE_DATA_LOAD,
			(vesselId: string, year: string) => ({
				vesselId,
				year,
			}),
		)(),
		cleaningChemicalsAllVesselAggregateDataLoad: createAction(
			EReportActions.REPORT_CLEANING_CHEMICALS_ALL_VESSEL_AGGREGATE_DATA_LOAD,
			(year: string) => ({
				year,
			}),
		)(),
		emissionsVesselSpecificAggregateDataLoad: createAction(
			EReportActions.REPORT_EMISSIONS_VESSEL_SPECIFIC_AGGREGATE_DATA_LOAD,
			(vesselId: string, year: string) => ({
				vesselId,
				year,
			}),
		)(),
		emissionsAllVesselAggregateDataLoad: createAction(
			EReportActions.REPORT_EMISSIONS_ALL_VESSEL_AGGREGATE_DATA_LOAD,
			(year: string) => ({
				year,
			}),
		)(),
		refrigerantVesselSpecificAggregateDataLoad: createAction(
			EReportActions.REPORT_REFRIGERANT_VESSEL_SPECIFIC_AGGREGATE_DATA_LOAD,
			(vesselId: string, year: string) => ({
				vesselId,
				year,
			}),
		)(),
		refrigerantAllVesselAggregateDataLoad: createAction(
			EReportActions.REPORT_REFRIGERANT_ALL_VESSEL_AGGREGATE_DATA_LOAD,
			(year: string) => ({
				year,
			}),
		)(),
		emfFleetUsageDataLoad: createAction(
			EReportActions.REPORT_FLEET_EMF_USAGE_DATA_LOAD,
			(yearMonth: string) => ({
				yearMonth,
			}),
		)(),
		biofouling1FleetDataLoad: createAction(
			EReportActions.REPORT_FLEET_BIOFOULING1_DATA_LOAD,
			(yearMonth: string) => ({
				yearMonth,
			}),
		)(),
		biofouling2FleetDataLoad: createAction(
			EReportActions.REPORT_FLEET_BIOFOULING2_DATA_LOAD,
			(yearMonth: string) => ({
				yearMonth,
			}),
		)(),
	},
	document: {
		reportVesselIdSet: createAction(
			EReportActions.REPORT_VESSEL_ID_SET,
			(vesselId: string) => ({ vesselId }),
		)(),
		reportVesselTypeSet: createAction(
			EReportActions.REPORT_VESSEL_TYPE_SET,
			(vesselType: string) => ({ vesselType }),
		)(),
		reportVesselClassSet: createAction(
			EReportActions.REPORT_VESSEL_CLASS_SET,
			(vesselClass: string) => ({ vesselClass }),
		)(),
		reportYearSet: createAction(
			EReportActions.REPORT_YEAR_SET,
			(year: string) => ({ year }),
		)(),
		reportFiltersSet: createAction(
			EReportActions.REPORT_FILTERS_SET,
			(filters: Record<string, any>) => ({ filters }),
		)(),
		reportPaginationSet: createAction(
			EReportActions.REPORT_PAGINATION_SET,
			(pagination: IPagination) => ({ pagination }),
		)(),
		garbageRawDataSet: createAction(
			EReportActions.REPORT_GARBAGE_RAW_DATA_SET,
			(garbageRawData: IGarbageRawRecord[]) => ({
				garbageRawData,
			}),
		)(),
		garbageCustomSearchDataSet: createAction(
			EReportActions.REPORT_GARBAGE_CUSTOM_SEARCH_DATA_SET,
			(garbageCustomSearchData: IGarbageCustomSearchRecord[]) => ({
				garbageCustomSearchData,
			}),
		)(),
		refrigerantCustomSearchDataSet: createAction(
			EReportActions.REPORT_REFRIGERANT_CUSTOM_SEARCH_DATA_SET,
			(refrigerantCustomSearchData: IRefrigerantCustomSearchRecord[]) => ({
				refrigerantCustomSearchData,
			}),
		)(),
		bilgeWaterCustomSearchDataSet: createAction(
			EReportActions.REPORT_BILGE_WATER_CUSTOM_SEARCH_DATA_SET,
			(bilgeWaterCustomSearchData: IBilgeWaterCustomSearchRecord[]) => ({
				bilgeWaterCustomSearchData,
			}),
		)(),
		packagingCustomSearchDataSet: createAction(
			EReportActions.REPORT_PACKAGING_CUSTOM_SEARCH_DATA_SET,
			(packagingCustomSearchData: IPackagingCustomSearchRecord[]) => ({
				packagingCustomSearchData,
			}),
		)(),
		cleaningChemicalsCustomSearchDataSet: createAction(
			EReportActions.REPORT_CLEANING_CHEMICALS_CUSTOM_SEARCH_DATA_SET,
			(
				cleaningChemicalsCustomSearchData: ICleaningChemicalsCustomSearchRecord[],
			) => ({
				cleaningChemicalsCustomSearchData,
			}),
		)(),
		orsCustomSearchDataSet: createAction(
			EReportActions.REPORT_ORS_CUSTOM_SEARCH_DATA_SET,
			(orsCustomSearchData: IORSCustomSearchRecord[]) => ({
				orsCustomSearchData,
			}),
		)(),
		cargoSlopCustomSearchDataSet: createAction(
			EReportActions.REPORT_CARGO_SLOP_CUSTOM_SEARCH_DATA_SET,
			(cargoSlopCustomSearchData: ICargoSlopCustomSearchRecord[]) => ({
				cargoSlopCustomSearchData,
			}),
		)(),
		emissionsCustomSearchDataSet: createAction(
			EReportActions.REPORT_EMISSIONS_CUSTOM_SEARCH_DATA_SET,
			(emissionsCustomSearchData: IEmissionsCustomSearchRecord[]) => ({
				emissionsCustomSearchData,
			}),
		)(),
		garbageReportVesselIdSet: createAction(
			EReportActions.REPORT_GARBAGE_VESSEL_ID_SET,
			(vesselId: string) => ({ vesselId }),
		)(),
		garbageReportYearSet: createAction(
			EReportActions.REPORT_GARBAGE_YEAR_SET,
			(year: string) => ({ year }),
		)(),
		bilgeWaterRawDataSet: createAction(
			EReportActions.REPORT_BILGE_WATER_RAW_DATA_SET,
			(bilgeWaterRawData?: IBilgeWaterRecord[]) => ({
				bilgeWaterRawData,
			}),
		)(),
		bilgeWaterReportVesselIdSet: createAction(
			EReportActions.REPORT_BILGE_WATER_VESSEL_ID_SET,
			(vesselId: string) => ({ vesselId }),
		)(),
		bilgeWaterReportYearSet: createAction(
			EReportActions.REPORT_BILGE_WATER_YEAR_SET,
			(year: string) => ({ year }),
		)(),
		bilgeWaterAllVesselDataSet: createAction(
			EReportActions.REPORT_BILGE_WATER_ALL_VESSELS_DATA_SET,
			(vesselBilgeWaterRecords: IBilgeWaterAllVesselAggregateRecord[]) => ({
				vesselBilgeWaterRecords,
			}),
		)(),
		garbageDischargeAllVesselDataSet: createAction(
			EReportActions.REPORT_ALL_VESSELS_GARBAGE_DISCHARGE_SET,
			(garbageDischargeRecords: IGarbageDischargeAllVesselsRecord[]) => ({
				garbageDischargeRecords,
			}),
		)(),
		garbageCategoryAllVesselDataSet: createAction(
			EReportActions.REPORT_ALL_VESSELS_GARBAGE_CATEGORY_SET,
			(garbageCategoryRecords: IGarbageCategoryAllVesselsRecord[]) => ({
				garbageCategoryRecords,
			}),
		)(),
		orsReportVesselIdSet: createAction(
			EReportActions.REPORT_ORS_VESSEL_ID_SET,
			(vesselId: string) => ({ vesselId }),
		)(),
		orsReportYearSet: createAction(
			EReportActions.REPORT_ORS_YEAR_SET,
			(year: string) => ({ year }),
		)(),
		orsRawDataSet: createAction(
			EReportActions.REPORT_ORS_AGGREGATE_DATA_SET,
			(rawOrsData: IORSAggregateRecord[]) => ({
				rawOrsData,
			}),
		)(),
		orsVesselSpecificRawDataSet: createAction(
			EReportActions.REPORT_ORS_VESSEL_SPECIFIC_AGGREGATE_DATA_SET,
			(rawVesselSpecificOrsData: IORSVesselSpecificAggregateRecord[]) => ({
				rawVesselSpecificOrsData,
			}),
		)(),
		cargoSlopRawDataSet: createAction(
			EReportActions.REPORT_CARGO_SLOP_AGGREGATE_DATA_SET,
			(rawCargoSlopData: ICargoSlopAggregateRecord[]) => ({
				rawCargoSlopData,
			}),
		)(),
		cargoSlopVesselSpecificRawDataSet: createAction(
			EReportActions.REPORT_CARGO_SLOP_VESSEL_SPECIFIC_AGGREGATE_DATA_SET,
			(
				rawVesselSpecificCargoSlopData: ICargoSlopVesselSpecificAggregateRecord[],
			) => ({
				rawVesselSpecificCargoSlopData,
			}),
		)(),
		oilSpillsInWaterRawDataSet: createAction(
			EReportActions.REPORT_OIL_SPILLS_IN_WATER_AGGREGATE_DATA_SET,
			(rawOilSpillsInWaterData: IOilSpillsInWaterAggregateRecord[]) => ({
				rawOilSpillsInWaterData,
			}),
		)(),
		oilSpillsInWaterVesselSpecificRawDataSet: createAction(
			EReportActions.REPORT_OIL_SPILLS_IN_WATER_VESSEL_SPECIFIC_AGGREGATE_DATA_SET,
			(
				rawVesselSpecificOilSpillsInWaterData: IOilSpillsInWaterVesselSpecificAggregateRecord[],
			) => ({
				rawVesselSpecificOilSpillsInWaterData,
			}),
		)(),
		comprehensiveNoonReportRawDataSet: createAction(
			EReportActions.REPORT_COMPREHENSIVE_NOON_REPORT_DATA_SET,
			(rawComprehensiveNoonReportData: IComprehensiveNoonReportRecord[]) => ({
				rawComprehensiveNoonReportData,
			}),
		)(),
		comprehensiveNoonReportVesselSpecificDataSet: createAction(
			EReportActions.REPORT_COMPREHENSIVE_NOON_REPORT_VESSEL_SPECIFIC_DATA_SET,
			(
				rawVesselSpefiicDataComprehensiveNoonReportData: IComprehensiveNoonReportVesselSpecificDataRecord[],
			) => ({
				rawVesselSpefiicDataComprehensiveNoonReportData,
			}),
		)(),
		cnrRangesVesselListSet: createAction(
			EReportActions.REPORT_CNR_RANGES_VESSEL_LIST_SET,
			(vesselList: ICNRRangeVessel[], type?: "add" | "update") => ({
				vesselList,
				type: !type ? "add" : type,
			}),
		)(),
		cnrRangesVesselListReset: createAction(
			EReportActions.REPORT_CNR_RANGES_VESSEL_LIST_RESET,
		)(),
		cnrRangesPaginationSet: createAction(
			EReportActions.REPORT_CNR_RANGES_PAGINATION_SET,
			(key: Partial<IPagination>) => ({
				key,
			}),
		)(),
		cnrRangesColumnsSet: createAction(
			EReportActions.REPORT_CNR_RANGES_COLUMNS_SET,
			(columns: ICNRRangeColumn[]) => ({
				columns,
			}),
		)(),
		cnrRangesVesselSubTypeSet: createAction(
			EReportActions.REPORT_CNR_RANGES_VESSEL_SUB_TYPE_SET,
			(vesselSubType?: string) => ({
				vesselSubType,
			}),
		)(),
		cnrRangesVesselsSelected: createAction(
			EReportActions.REPORT_CNR_RANGES_VESSELS_SELECTED,
			(vesselsSelected?: string[]) => ({
				vesselsSelected,
			}),
		)(),
		cnrRangesReportTypeSelected: createAction(
			EReportActions.REPORT_CNR_RANGES_REPORT_TYPE_SELECTED,
			(reportType?: string) => ({
				reportType,
			}),
		)(),
		cnrRangesBaseRangeTypeSet: createAction(
			EReportActions.REPORT_CNR_RANGES_BASE_RANGE_TYPE_SET,
			(baseRangeType: ECNR_BASE_RANGE_TYPE) => ({
				baseRangeType,
			}),
		)(),
		cnrRangesConfigSet: createAction(
			EReportActions.REPORT_CNR_RANGES_CONFIG_SET,
			(config: any) => ({
				config,
			}),
		)(),
		cnrRangesRangeInfoSet: createAction(
			EReportActions.REPORT_CNR_RANGES_RANGE_INFO_SET,
			(rangeInfo?: ICNRRangeVesselLocalRange) => ({
				rangeInfo,
			}),
		)(),
		cnrRangesIsEditModalVisibleToggle: createAction(
			EReportActions.REPORT_CNR_RANGES_IS_EDIT_MODAL_VISIBLE_TOGGLE,
			(isEditModalVisible?: boolean) => ({
				isEditModalVisible,
			}),
		)(),
		navnucRawDataSet: createAction(
			EReportActions.REPORT_NAVNUC_SET,
			(rawNavnucData: any) => ({
				rawNavnucData,
			}),
		)(),
		// Environmental Report (EMF) actions
		packagingVesselSpecificAggregateDataSet: createAction(
			EReportActions.REPORT_PACKAGING_VESSEL_SPECIFIC_AGGREGATE_DATA_SET,
			(
				packagingVesselSpecificAggregateData: IPackagingVesselSpecificAggregatedData[],
			) => ({
				packagingVesselSpecificAggregateData,
			}),
		)(),
		packagingAllVesselAggregateDataSet: createAction(
			EReportActions.REPORT_PACKAGING_ALL_VESSEL_AGGREGATE_DATA_SET,
			(
				packagingAllVesselAggregateData: IPackagingAllVesselAggregatedData[],
			) => ({
				packagingAllVesselAggregateData,
			}),
		)(),
		cleaningChemicalsVesselSpecificAggregateDataSet: createAction(
			EReportActions.REPORT_CLEANING_CHEMICALS_VESSEL_SPECIFIC_AGGREGATE_DATA_SET,
			(
				cleaningChemicalsVesselSpecificAggregateData: ICleaningChemicalsVesselSpecificAggregatedData[],
			) => ({
				cleaningChemicalsVesselSpecificAggregateData,
			}),
		)(),
		cleaningChemicalsAllVesselAggregateDataSet: createAction(
			EReportActions.REPORT_CLEANING_CHEMICALS_ALL_VESSEL_AGGREGATE_DATA_SET,
			(
				cleaningChemicalsAllVesselAggregateData: ICleaningChemicalsAllVesselAggregatedData[],
			) => ({
				cleaningChemicalsAllVesselAggregateData,
			}),
		)(),
		emissionsVesselSpecificAggregateDataSet: createAction(
			EReportActions.REPORT_EMISSIONS_VESSEL_SPECIFIC_AGGREGATE_DATA_SET,
			(
				emissionsVesselSpecificAggregateData: IEmissionsVesselSpecificAggregatedData[],
			) => ({
				emissionsVesselSpecificAggregateData,
			}),
		)(),
		emissionsAllVesselAggregateDataSet: createAction(
			EReportActions.REPORT_EMISSIONS_ALL_VESSEL_AGGREGATE_DATA_SET,
			(
				emissionsAllVesselAggregateData: IEmissionsAllVesselAggregatedData[],
			) => ({
				emissionsAllVesselAggregateData,
			}),
		)(),
		refrigerantVesselSpecificAggregateDataSet: createAction(
			EReportActions.REPORT_REFRIGERANT_VESSEL_SPECIFIC_AGGREGATE_DATA_SET,
			(
				refrigerantVesselSpecificAggregateData: IRefrigerantVesselSpecificAggregatedData[],
			) => ({
				refrigerantVesselSpecificAggregateData,
			}),
		)(),
		refrigerantAllVesselAggregateDataSet: createAction(
			EReportActions.REPORT_REFRIGERANT_ALL_VESSEL_AGGREGATE_DATA_SET,
			(
				refrigerantAllVesselAggregateData: IRefrigerantAllVesselAggregatedData[],
			) => ({
				refrigerantAllVesselAggregateData,
			}),
		)(),
		emfFleetUsageDataSet: createAction(
			EReportActions.REPORT_FLEET_EMF_USAGE_DATA_SET,
			(emfUsageDataSet: TEMFUsageData[]) => ({
				emfUsageDataSet,
			}),
		)(),
		biofouling1FleetDataSet: createAction(
			EReportActions.REPORT_FLEET_BIOFOULING1_DATA_SET,
			(biofouling1Data: TBFL1UsageData[]) => ({
				biofouling1Data,
			}),
		)(),
		biofouling2FleetDataSet: createAction(
			EReportActions.REPORT_FLEET_BIOFOULING2_DATA_SET,
			(biofouling2Data: TBFL2UsageData[]) => ({
				biofouling2Data,
			}),
		)(),
	},
};

export const reportJobActions = {
	garbageReportLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.garbageReportLoad),
	),
	garbageCustomSearchLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.garbageCustomSearchLoad),
	),
	refrigerantCustomSearchLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.refrigerantCustomSearchLoad),
	),
	bilgeWaterCustomSearchLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.bilgeWaterCustomSearchLoad),
	),
	packagingCustomSearchLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.packagingCustomSearchLoad),
	),
	cleaningChemicalsCustomSearchLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.cleaningChemicalsCustomSearchLoad),
	),
	orsCustomSearchLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.orsCustomSearchLoad),
	),
	cargoSlopCustomSearchLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.cargoSlopCustomSearchLoad),
	),
	emissionsCustomSearchLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.emissionsCustomSearchLoad),
	),
	bilgeWaterReportLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.bilgeWaterReportLoad),
	),
	bilgeWaterAllVesselsAggregateLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.bilgeWaterAllVesselsAggregateLoad),
	),
	allVesselsGarbageDischargeLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.garbageDischargeAllVesselsLoad),
	),
	allVesselsGarbageCategoryLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.garbageCategoryAllVesselsLoad),
	),
	vesselSpecificOrsAggregateLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.orsVesselSpecificAggregateLoad),
	),
	allVesselOrsAggregateLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.orsAllVesselAggregateLoad),
	),
	vesselSpecificCargoSlopAggregateLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.cargoSlopVesselSpecificAggregateLoad),
	),
	allVesselCargoSlopAggregateLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.cargoSlopAllVesselAggregateLoad),
	),
	vesselSpecificOilSpillsInWaterAggregateLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.oilSpillsInWaterVesselSpecificAggregateLoad),
	),
	allVesselOilSpillsInWaterAggregateLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.oilSpillsInWaterAllVesselAggregateLoad),
	),
	allVesselComprehensiveNoonReportLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.comprehensiveNoonReportAllVesselLoad),
	),
	vesselSpecificComprehensiveNoonReportDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(
			reportActions.commands.comprehensiveNoonReportVesselSpecificDataLoad,
		),
	),
	cnrRangesVesselsLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.cnrRangesVesselsLoad),
	),
	cnrRangesVesselSubTypeConfigLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.cnrRangesVesselSubTypeConfigLoad),
	),
	cnrRangesRangeCellUpdate: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.cnrRangesRangeCellUpdate),
	),
	navnucLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.navnucLoad),
	),
	cnrRangesCSVFileUpload: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.cnrRangesCSVFileUpload),
	),
	packagingAllVesselsAggregateDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.packagingAllVesselAggregateDataLoad),
	),
	packagingVesselSpecificAggregateDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.packagingVesselSpecificAggregateDataLoad),
	),
	cleaningChemicalsAllVesselsAggregateDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.cleaningChemicalsAllVesselAggregateDataLoad),
	),
	cleaningChemicalsVesselSpecificAggregateDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(
			reportActions.commands.cleaningChemicalsVesselSpecificAggregateDataLoad,
		),
	),
	emissionsAllVesselsAggregateDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.emissionsAllVesselAggregateDataLoad),
	),
	emissionsVesselSpecificAggregateDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.emissionsVesselSpecificAggregateDataLoad),
	),
	refrigerantAllVesselsAggregateDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.refrigerantAllVesselAggregateDataLoad),
	),
	refrigerantVesselSpecificAggregateDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.refrigerantVesselSpecificAggregateDataLoad),
	),
	emfFleetUsageDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.emfFleetUsageDataLoad),
	),
	biofouling1FleetDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.biofouling1FleetDataLoad),
	),
	biofouling2FleetDataLoad: jobActions(
		reportConstants.FEATURE,
		getType(reportActions.commands.biofouling2FleetDataLoad),
	),
};

export type TReportActions = ActionType<typeof reportActions>;
export default reportActions;
